module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_4_3_w_900.ba65d0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_900.jpg
// module id = YE6l
// module chunks = 0